module.exports = __webpack_public_path__ + "img/support.d2591482.svg";